import styled from "styled-components"
import { Span } from "../typography"

const SpaceBetweenWrapper = styled(Span).attrs(() => ({ as: "div" }))`
  display: flex;
  justify-content: space-between;
  align-items: inherits;
  ${(props) => props.noAlignCenter && "align-items: unset;"}
  @media (max-width: 520px) {
    ${(props) => props.mColumn && "flex-direction: column;"}
  }
`

export default SpaceBetweenWrapper
